import React from 'react';
import { Chip, Tooltip } from "@mui/material";

interface DemoBadgeProps {
  view: string;
}

const DemoBadge = ({ view }: DemoBadgeProps): JSX.Element => {

  if (view === 'list') {
    return (
      <Tooltip title="Open Box">
        <Chip
          label="OB"
          size="small"
          sx={{
            background: "#A1D899",
            color: "#006100",
            fontSize: "10px",
            height: "16px",
            borderRadius: '4px',
            marginLeft: '4px',
          }}
        />
      </Tooltip>
    );
  }
  else {
    return (
      <Tooltip title="Open Box">
        <Chip
          label="OB"
          size="small"
          sx={{
            background: "#A1D899",
            color: "#006100",
            height: "20px",
            borderRadius: "4px",
            marginRight: "4px",
          }}
        />
      </Tooltip>
    );
  }
};

export default DemoBadge;